{
  "ChangeLang_Title": "Change Language",
  "ChangeLang_Subtitle": "Select the language you wish to view web page content in within your current web session on this computer.",
  "ChangeLang_Field_Label": "Language",
  "ChangeLang_Remember_Label": "Remember my selection",
  "ChangeLang_Buttons_Apply": "Apply",
  "ChangeLang_Buttons_Cancel": "Cancel",
  "NAME": "ChangeLangLanguage"
}